<template>
  <div class="umdb-boardlist">
    <b-table
      :items="items"
      :fields="fields"
      sort-by="releaseDate"
      sort-null-last
      responsive
      class="compact-table-sm"
    >
      <template v-slot:cell(name)="card">
        <b-img-lazy
          :src="card.item.image"
          blank-color="#7777"
          fluid
          width="200"
          height="125"
          class="mr-2 mr-md-4"
          v-if="card.item.image"
        />
        <span>{{ card.value }}</span>
      </template>
      <template v-slot:row-details="row">
        <div
          v-if="row.item.notes"
          class="mx-4 border p-2 p-md-4 rounded-lg note"
          v-html="parseMarkdown(row.item.notes)"
        ></div>
      </template>
    </b-table>
  </div>
</template>

<script>
import markdown from "@/mixins/markdown";
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "UmDbSetList",
  mixins: [markdown, dateFormat],
  data() {
    return {
      fields: [
        {
          key: "name",
          sortable: true,
          label: "Board",
        },
        {
          key: "max_players",
          label: "Max. players",
          tdClass: ["text-right"],
          thClass: ["text-right vertical"],
          sortable: true,
        },
        {
          key: "spaces_count",
          label: "Spaces",
          tdClass: ["text-right"],
          thClass: ["text-right vertical"],
          sortable: true,
        },
        {
          key: "zone_count",
          label: "Zones",
          tdClass: ["text-right"],
          thClass: ["text-right vertical"],
          sortable: true,
        },
      ],
    };
  },
  props: {
    boards: {
      type: Array,
      required: true,
    },
  },
  computed: {
    items() {
      return this.boards.map((board) => ({
        ...board,
        _showDetails: !!board.notes,
      }));
    },
  },
};
</script>

<style lang="scss">
.umdb-boardlist {
  td {
    vertical-align: middle;
  }

  .note p:last-child {
    margin-bottom: 0;
  }
}
</style>
